// Copyright (c) 2016 Deere & Company

import IncentiveProgram from '@deere/cps-it.warranty-model-factory/lib/incentive-programs';
import t from 'tcomb';

const IncentivePrograms = t.list(IncentiveProgram, 'IncentivePrograms');

export const getDefaultState = () => new IncentivePrograms([]);

export default IncentivePrograms;



// WEBPACK FOOTER //
// ./src/product/details/state/incentive-programs.js